<template>
  <el-dialog title="详情" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-descriptions :column="1">
      <el-descriptions-item label="客户名称">{{form.customerName}}</el-descriptions-item>
      <el-descriptions-item label="客户编码">{{form.customerCode}}</el-descriptions-item>
      <el-descriptions-item label="旧城市公司">{{form.oldCityCompanyName}}</el-descriptions-item>
      <el-descriptions-item label="新城市公司">{{form.newCityCompanyName}}</el-descriptions-item>
      <el-descriptions-item label="零售价">{{form.customerChangeCityCompanyPO && form.customerChangeCityCompanyPO.xiaoduMoney}}</el-descriptions-item>
      <el-descriptions-item label="余额">{{form.customerChangeCityCompanyPO && form.customerChangeCityCompanyPO.balance}}</el-descriptions-item>
      <el-descriptions-item label="学费">{{form.customerChangeCityCompanyPO && form.customerChangeCityCompanyPO.tuition}}</el-descriptions-item>
      <el-descriptions-item label="积分">{{form.customerChangeCityCompanyPO && form.customerChangeCityCompanyPO.integral}}</el-descriptions-item>
      <el-descriptions-item label="推送日志零售价旧账套下账">{{form.sendLog}}</el-descriptions-item>
      <el-descriptions-item label="推送日志零售价新账套上账">{{form.sendLog2}}</el-descriptions-item>
      <el-descriptions-item label="推送日志学费旧账套下账">{{form.sendLog3}}</el-descriptions-item>
      <el-descriptions-item label="推送日志学费新账套上账">{{form.sendLog4}}</el-descriptions-item>
      <el-descriptions-item label="推送日志余额旧账套下账">{{form.sendLog5}}</el-descriptions-item>
      <el-descriptions-item label="推送日志余额新账套上账">{{form.sendLog6}}</el-descriptions-item>
     
    </el-descriptions>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      form: {},
      formVisible: false,
      formRules: {
      },
    }
  },
  created() {

  },
  methods: {
    handleUpdate(row) {
      this.form = { ...row }
      this.formVisible = true
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
